// src/pages/usa/colorado/GrandLake.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

// ⭐ STRICT COMMAND: Aspen ALWAYS goes back to Colorado map
export const backRoute = "/map/colorado";

export default function GrandLake() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__grandlakeBackRouteSet) {
      window.__grandlakeBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Grand Lake, Colorado</h1>

        <section className="travel-review">
          <div className="travel-text">
            <h2>Discover Grand Lake, Colorado</h2>


            <p>
  Grand Lake, Colorado, sits in the heart of the Rocky Mountains and feels like a true mountain escape. With
   its wide-open lake views, tall surrounding peaks, and quiet small-town atmosphere, it’s a place where the
    scenery does most of the talking. The town rests along the shores of Grand Lake — the largest natural lake
     in Colorado — giving it a calm, open feel that’s perfect for anyone who loves being close to the water.
</p>

<p>
  It’s a year-round destination: boating, kayaking, and fishing in the summer; snowshoeing, snowmobiling, and 
  nearby skiing in the winter. The wooden boardwalks, local shops, and classic cabins give the town a relaxed, 
  old-west character. Whether you’re exploring trails, spending time on the lake, or just taking in the mountain 
  views, Grand Lake delivers a simple, memorable Colorado experience.
</p>


            <h3>🚗 Getting There</h3>

            <p>
  Heading to Grand Lake is an adventure in itself. The most scenic route is Trail Ridge Road (Highway 34), 
  which winds through Rocky Mountain National Park and offers wide, dramatic views of the surrounding peaks 
  and valleys. This drive is especially beautiful in the fall when the aspen trees turn golden. Just keep
   in mind that Trail Ridge Road is typically closed from October to May due to snow. For a reliable 
   year‑round option, take Highway 40 west from I‑70, which leads directly into Grand Lake.
</p>



            {/* 🌟 MY PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                <strong>Adams Falls:</strong> A small but impressive waterfall just outside the town of Grand Lake. 
                The hike is short and easy, making it perfect for families or anyone looking for a
                 quick outing. The trail moves through a forested area and leads to a viewpoint where
                  the water drops into a calm pool below. You can continue exploring past the falls
                   for wider views of the lake, wildlife, and surrounding mountains.
 
                  <br />
                  <a
                    href="https://www.google.com/maps?q=40.23664249685409, -105.79789155741922"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Adams Falls
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>The Lake:</strong> The lake of Grand Lake is a pristine body of water surrounded
                   by towering peaks and forests. It offers opportunities for boating, paddle boarding, kayaking and other 
                   water activities.<br />
                  <a
                    href="https://www.google.com/maps?q=40.24106911526681, -105.80524103723532"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 The Lake
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>The Town:</strong> Grand Lake is a charming, historic community set right along the 
                  shoreline of the lake. It offers a mix of restaurants, shops, and lodging options, all 
                  centered around its classic main street. The boardwalk-style strip runs from one end of 
                  town to the other, lined with local businesses and small attractions that give the area 
                  its welcoming, mountain‑town character.
<br />
                  <a
                    href="https://www.google.com/maps?q=40.25217631868038, -105.82258927134022"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 The Town
                  </a>
                </div>
              </li>
            </ul>

            {/* 🏔️ HIDDEN GEMS */}
            <h3>🏔️ Hidden Gems in Grand Lake</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Lookout Tower:</strong> Although it sits within Rocky Mountain National Park, this
                   fire lookout is close enough to Grand Lake that many visitors treat it as part of the 
                   area. The trail is a bit off the main paths and leads to wide, panoramic views of the 
                   surrounding mountains and valleys. It’s a great spot for sunrise or sunset. Based on 
                   reviews—and on my own list—it’s a place I plan to visit the next time I’m in Grand Lake.
                   <a
                    href="https://www.google.com/maps?q=40.23006812378233, -105.81416580942772"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Lookout Tower
                  </a>

                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Rainbow Bridge:</strong> This small bridge sits at the edge of town and crosses 
                  the channel that connects Grand Lake and Shadow Mountain Lake. The view from the bridge
                   is spectacular, especially during sunrise or sunset, when the light reflects across the
                    water and the mountains in the distance. It’s also a popular spot for photos and a quick
                     stop before heading toward the Lookout Tower or the trails on the south side of town.
                    <a
                    href="https://www.google.com/maps?q=40.245948349647946, -105.82873308874072"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Rainbow Bridge
                  </a> 

                </div>
              </li>

             
            </ul>

           {/* 🛏️ PLACES TO STAY */}
<h3>🛏️ Places to Stay in Grand Lake</h3>

<p>
  Grand Lake offers a mix of lakeside cabins, cozy lodges, and small mountain inns. These stays are well‑rated
  and consistently recommended by travelers:
</p>

<ul>
  <li>
    <div className="place-block">
      <strong>Grand Lake Lodge:</strong> Historic lodge with cabins, lake views, and direct access to Rocky Mountain National Park.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Western Riviera Lakeside Lodging:</strong> Waterfront rooms and cabins right on the edge of Grand Lake.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Spirit Lake Lodge:</strong> Central location with comfortable rooms and easy access to town and trails.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Gateway Inn:</strong> Rustic‑style lodge with mountain views and a warm, classic Colorado atmosphere.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Shadowcliff Mountain Lodge:</strong> Eco‑friendly lodge overlooking the lake, known for its quiet setting.
    </div>
  </li>
</ul>

<h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>

            {/* 🎥 VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>Here are some videos I took from Grand Lake.</p>

        <p>
  <a
    href="https://youtu.be/sJpVnXwltHI?si=6ME81UgrvoBZi5wv"
    target="_blank"
    rel="noopener noreferrer"
  >
    Grand Lake Town Video
  </a>
</p>
<p>
  <a
    href="https://youtu.be/ZDVa-KVBAGw?si=7fHnQA-FGEBid7sG"
    target="_blank"
    rel="noopener noreferrer"
  >
    Grand Lake Lake Video
  </a>
</p>
</div>

{/* RIGHT COLUMN — IMAGES */}
<div className="travel-image-column">
  <a
    href="https://youtu.be/sJpVnXwltHI?si=6ME81UgrvoBZi5wv"
    target="_blank"
    rel="noopener noreferrer"
    className="youtube-image-card"
  >
    <img
      src="/images/usa/colorado/grandlake/tw3.jpg"
      alt="Grand Lake Video"
    />
  </a>
  
  <a
    href="https://youtu.be/ZDVa-KVBAGw?si=7fHnQA-FGEBid7sG"
    target="_blank"
    rel="noopener noreferrer"
    className="youtube-image-card"
  >
    <img
      src="/images/usa/colorado/grandlake/gl1.jpg"
      alt="Grand Lake, Lake Video"
    />
  </a>

   

  <img src="/images/usa/colorado/grandlake/tw1.jpg" alt="Town" />
  <img src="/images/usa/colorado/grandlake/tw2.jpg" alt="Town" />
  <img src="/images/usa/colorado/grandlake/tw4.jpg" alt="Town" />
  <img src="/images/usa/colorado/grandlake/gl2.jpg" alt="Grand Lake" />
  <img src="/images/usa/colorado/grandlake/gl3.jpg" alt="Grand Lake" />
  <img src="/images/usa/colorado/grandlake/gl5.jpg" alt="Grand Lake" />
  <img src="/images/usa/colorado/grandlake/gl6.jpg" alt="Grand Lake" />
  <img src="/images/usa/colorado/grandlake/gl8.jpg" alt="Grand Lake" />
  <img src="/images/usa/colorado/grandlake/ad1.jpg" alt="Adams Falls" />
  <img src="/images/usa/colorado/grandlake/ad2.jpg" alt="Adams Falls" />
  <img src="/images/usa/colorado/grandlake/ad3.jpg" alt="Adams Falls" />
  <img src="/images/usa/colorado/grandlake/ad4.jpg" alt="Adams Falls" />
  <img src="/images/usa/colorado/grandlake/ad5.jpg" alt="Adams Falls" />
  <img src="/images/usa/colorado/grandlake/rv5.jpg" alt="River" />
  <img src="/images/usa/colorado/grandlake/rv4.jpg" alt="River" />
  <img src="/images/usa/colorado/grandlake/rv6.jpg" alt="River" />
    <img src="/images/usa/colorado/grandlake/rv2.jpg" alt="River" />
</div>
</section>
</div>

{/* Centered email button */}
<div className="email-wrapper">
  <button className="email-link" onClick={() => setOpen(true)}>
    contact@thefindingspot.com
  </button>
</div>

{/* Popup */}
<ContactPopup isOpen={open} onClose={() => setOpen(false)} />

<Footer />
</>
);
}
